import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class RoomClosedChatMessage extends AbstractChatMessage {
  type = MessageTypes.ROOM_CLOSED
  body: {
    reason: string
  }

  constructor(data: LX.RoomClosedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.RoomClosedChatMessage) {
    return new RoomClosedChatMessage(data)
  }

  getShortMessage() {
    return 'This room has been closed'
  }
}
